import { ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

// partial types
type OldProject = {
  id: string;
  publishHistory: OldPublishHistory;
};
type OldPublishHistory = {
  connectionInfo: {
    databaseId: string;
    namespaceIri: string;
    namespacePrefix: string;
    shouldAddNamespace: boolean;
    shouldEnableVoicebox?: boolean;
  };
  isPublishingSPG: boolean;
};

type Project = {
  id: string;
  publishHistory: PublishHistory;
};
type PublishHistory = {
  connectionInfo: {
    databaseId: string;
  };
  databaseInfo: {
    namespaceIri: string;
    namespacePrefix: string;
    shouldAddNamespace: boolean;
    shouldEnableVoicebox?: boolean;
    isPublishingSPG: boolean;
  };
};

/**
 * * on {@link Project} move `connectionInfo` in `publishHistory` to `databaseInfo`
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v33 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v30Projects(prevState.projects);
  }

  return nextState;
};

const v30Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, OldProject>
  ).forEach(([projectId, project]) => {
    const {
      connectionInfo: { databaseId, ...databaseInfo },
      isPublishingSPG,
      ...publishHistory
    } = project.publishHistory;

    projectsById[projectId] = {
      ...project,
      publishHistory: {
        ...publishHistory,
        connectionInfo: {
          databaseId,
        },
        databaseInfo: {
          ...databaseInfo,
          isPublishingSPG,
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
